import React, { FunctionComponent } from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    noDataFoundContainer: {
        width: '100%',
        maxHeight: 300,
        color: 'gray',
    },
    noDataFoundTitle: {
        fontSize: '24px',
        color: '#484848',
        lineHeight: '24px',
        fontWeight: 600,
        marginTop: '1rem',
        textAlign: 'center',
    },
    noDataFoundMessage: {
        fontSize: '18px',
        color: '#484848',
        lineHeight: '24px',
        marginTop: '20px',
        fontWeight: 500,
        textAlign: 'center',
    },
});

type TableEmptyStateProps = {
    title: string;
    message: string;
};

const TableEmptyState: FunctionComponent<TableEmptyStateProps> = (props) => {
    const classes = useStyles();
    const { title, message } = props;

    return (
        <Box className={classes.noDataFoundContainer} display="flex" flexDirection="column">
            <Box className={classes.noDataFoundTitle} display="flex" justifyContent="center">
                {title}
            </Box>
            <Box className={classes.noDataFoundMessage} display="flex" justifyContent="center">
                {message}
            </Box>
        </Box>
    );
};

export default TableEmptyState;
